import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ce1bf06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dictionary section-type-selector" }
const _hoisted_2 = { class: "card bg-light mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Section", -1))
const _hoisted_7 = {
  key: 1,
  class: "col-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#dictionary-types-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Type", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "fa fa-check success"
}
const _hoisted_12 = { class: "col-md-10" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  key: 0,
  class: "fa fa-check success"
}
const _hoisted_15 = { class: "col-md-10" }
const _hoisted_16 = {
  key: 2,
  class: "col-6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#dictionary-items-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Item", -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  key: 0,
  class: "fa fa-check success"
}
const _hoisted_21 = { class: "col-md-8" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  key: 0,
  class: "fa fa-check success"
}
const _hoisted_24 = { class: "col-md-8" }

import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import DictionaryTypesModal from '@/components/modals/DictionaryTypesModal.vue';
  import DictionaryItemsModal from '@/components/modals/DictionaryItemsModal.vue';
  
  import fixflocategories from '@/store/dictionary/json/fixflocategories.json';
  
  // Models can remain the same
  import { DictionarySection, DictionaryType, DictionaryItem } from '@/models';
  import { DictionaryState } from '@/store/dictionary/types';
  
  // Define props with type annotations
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FixfloSelector',
  props: {
    showSections: { type: Boolean },
    showTypes: { type: Boolean },
    showItems: { type: Boolean }
  },
  setup(__props: any) {

  const props = __props;
  
  const store = useStore();
  
  // Computed properties for getting state values
  const dictionaryState = computed(() => store.state.dictionary as DictionaryState);
  
  // Computed properties with getters and setters for activeSection, activeType, and activeItem
  const activeSection = computed<DictionarySection>({
    get: () => dictionaryState.value.activeSection,
    set: (val: DictionarySection) => {
      store.commit('dictionary/setActiveSection', val);
      unsetActiveType();
    },
  });
  
  const activeType = computed<DictionaryType>({
    get: () => dictionaryState.value.activeType,
    set: (val: DictionaryType) => {
      store.commit('dictionary/setActiveType', val);
      unsetActiveItem();
    },
  });
  
  const activeItem = computed<DictionaryItem>({
    get: () => dictionaryState.value.activeItem,
    set: (val: DictionaryItem) => {
      store.commit('dictionary/setActiveItem', val);
    },
  });
  
  // Methods are simply converted to functions
  function unsetActiveSection() {
    store.commit('dictionary/setActiveSection', new DictionarySection());
    unsetActiveType();
  }
  
  function unsetActiveType() {
    store.commit('dictionary/setActiveType', new DictionaryType());
    unsetActiveItem();
  }
  
  function unsetActiveItem() {
    store.commit('dictionary/setActiveItem', new DictionaryItem());
  }
  
  function getSystemName(type: DictionaryType): string {
    return type.getSystemName();
  }
  
  // Computed properties for the getters
  const allSections = computed(() => store.getters['dictionary/allSections'] as DictionarySection[]);
  const currentTypes = computed(() => store.getters['dictionary/currentTypes'] as DictionaryType[]);
  const currentItems = computed(() => store.getters['dictionary/currentItems'] as DictionaryItem[]);
  
  const hasActiveSection = computed(() => store.getters['dictionary/hasActiveSection'] as boolean);
  const hasActiveType = computed(() => store.getters['dictionary/hasActiveType'] as boolean);
  const hasActiveItem = computed(() => store.getters['dictionary/hasActiveItem'] as boolean);
  
  //for activeType
  const fixfloCategoryForType = computed({
    get: () => {
      return activeType.value.fixflocategory;
    },
    set:(val: string) => {
      activeType.value.fixflocategory = val;
      activeType.value.fixflosubcategory = '';
    }
  });
  const fixfloSubCategoryForType = computed({
    get: () => {
      return activeType.value.fixflosubcategory;
    },
    set:(val: string) => {
      activeType.value.fixflosubcategory = val;
    }
  });
  
  const fixfloCategoryOptions = computed(() => {
    return fixflocategories.map((c: any) => c.name).sort();
  });
  const fixfloSubCategoryOptions = computed(() => {
    const index = fixflocategories.findIndex((c: any) => c.name === fixfloCategoryForType.value);
    var list: string[] = [];
    if(index >= 0) {
      list = fixflocategories[index].subcategories;
    }
    return list.sort();
  });
  
  //for activeItem
  const fixfloCategoryForItem = computed({
    get: () => {
      return activeItem.value.fixflocategory;
    },
    set:(val: string) => {
      activeItem.value.fixflocategory = val;
      activeItem.value.fixflosubcategory = '';
    }
  });
  
  const fixfloSubCategoryForItem = computed({
    get: () => {
      return activeItem.value.fixflosubcategory;
    },
    set:(val: string) => {
      activeItem.value.fixflosubcategory = val;
    }
  });
  
  const fixfloItemCategoryOption = computed(() => {
    return fixflocategories.map((c: any) => c.name).sort();
  });
  const fixfloSubCategoryOption = computed(() => {
    const index = fixflocategories.findIndex((c: any) => c.name === fixfloCategoryForItem.value);
    var list: string[] = [];
    if(index >= 0) {
      list = fixflocategories[index].subcategories;
    }
    return list.sort();
  });
  
  
return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showSections)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_multiselect, {
                  modelValue: activeSection.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSection).value = $event)),
                  "track-by": "slug",
                  options: allSections.value
                }, _createSlots({ _: 2 }, [
                  (hasActiveSection.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _withModifiers(unsetActiveSection, ["prevent","stop"]),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Job Type"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTypes && hasActiveSection.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_multiselect, {
                  modelValue: activeType.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeType).value = $event)),
                  "track-by": "slug",
                  options: currentTypes.value
                }, _createSlots({
                  singleLabel: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        (props.option.fixflocategory && props.option.fixflosubcategory)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(props.option.getSystemName()), 1)
                    ])
                  ]),
                  option: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", null, [
                        (props.option.fixflocategory && props.option.fixflosubcategory)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(props.option.getSystemName()), 1)
                    ])
                  ]),
                  _: 2
                }, [
                  (hasActiveType.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _withModifiers(unsetActiveType, ["prevent","stop"]),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Job Type"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"]),
                (hasActiveType.value)
                  ? (_openBlock(), _createBlock(_component_singleselect_text, {
                      key: 0,
                      class: "mt-2",
                      modelValue: fixfloCategoryForType.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fixfloCategoryForType).value = $event)),
                      options: fixfloCategoryOptions.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloCategoryForType.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (fixfloCategoryForType.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]))
                  : _createCommentVNode("", true),
                (fixfloCategoryForType.value)
                  ? (_openBlock(), _createBlock(_component_singleselect_text, {
                      key: 1,
                      class: "mt-2",
                      modelValue: fixfloSubCategoryForType.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fixfloSubCategoryForType).value = $event)),
                      options: fixfloSubCategoryOptions.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloSubCategoryForType.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (fixfloSubCategoryForType.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showItems && hasActiveType.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _createVNode(_component_multiselect, {
                  modelValue: activeItem.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeItem).value = $event)),
                  "track-by": "slug",
                  options: currentItems.value
                }, _createSlots({
                  singleLabel: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", null, [
                        (props.option.fixflocategory && props.option.fixflosubcategory)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(props.option.name), 1)
                    ])
                  ]),
                  option: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", null, [
                        (props.option.fixflocategory && props.option.fixflosubcategory)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(props.option.name), 1)
                    ])
                  ]),
                  _: 2
                }, [
                  (hasActiveItem.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _withModifiers(unsetActiveItem, ["prevent","stop"]),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Job Type"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"]),
                (hasActiveItem.value)
                  ? (_openBlock(), _createBlock(_component_singleselect_text, {
                      key: 0,
                      class: "mt-2",
                      modelValue: fixfloCategoryForItem.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((fixfloCategoryForItem).value = $event)),
                      options: fixfloItemCategoryOption.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloCategoryForItem.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (fixfloCategoryForItem.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]))
                  : _createCommentVNode("", true),
                (fixfloCategoryForItem.value)
                  ? (_openBlock(), _createBlock(_component_singleselect_text, {
                      key: 1,
                      class: "mt-2",
                      modelValue: fixfloSubCategoryForItem.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fixfloSubCategoryForItem).value = $event)),
                      options: fixfloSubCategoryOption.value
                    }, _createSlots({ _: 2 }, [
                      (fixfloSubCategoryForItem.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (fixfloSubCategoryForItem.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Job Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(DictionaryTypesModal),
    _createVNode(DictionaryItemsModal)
  ]))
}
}

})